import React, { useCallback } from 'react';
import { ModalContent } from 'fronton-react';
import {
  CategoryCardHeader,
  CategoryCardMedia,
  CategoryCardWithGAClickButton,
  ModalHeader,
  SwiperSlide,
  SwiperWithNavigation,
  Typography,
} from 'common/components';
import { createElementKey } from 'utils';
import { analyticsUtils, ClickButtonElementName } from 'utils/analytics-utils';
import { KITCHEN_ELEMENT_BLOCK } from '../../../../../kitchen-constants';
import {
  allPurchasesCategoryCard,
  allPurchasesModalContent,
  allPurchasesCategoryCardName,
  allPurchasesModalImage,
  allPurchasesModalSlide,
  allPurchasesModalSwiper,
  allPurchasesModalText,
} from './all-purchases-modal-styles';
import { useCategoriesListSelector } from '../../../../hooks';
import { KitchenAdditionalItemStructure } from '../../../../old-kitchen-types';

export const AllPurchasesModal = () => {
  const additionalList = useCategoriesListSelector();

  /**
   * Обработчик нажатия кнопки "Следующий слайд"
   */
  const handleNextSlideBtnClick = useCallback(() => {
    analyticsUtils.clickButtonEvent(
      KITCHEN_ELEMENT_BLOCK,
      ClickButtonElementName.SwitchForward,
      'Все покупки в Лемана ПРО / modal'
    );
  }, []);

  /**
   * Обработчик нажатия кнопки "Предыдущий слайд"
   */
  const handlePrevSlideBtnClick = useCallback(() => {
    analyticsUtils.clickButtonEvent(
      KITCHEN_ELEMENT_BLOCK,
      ClickButtonElementName.SwitchBackward,
      'Все покупки в Лемана ПРО / modal'
    );
  }, []);

  return (
    <>
      <ModalHeader title="Все покупки в&nbsp;Лемана&nbsp;ПРО" />
      <ModalContent className={allPurchasesModalContent}>
        <Typography className={allPurchasesModalText} variant="m" size="body_long">
          У&nbsp;нас вы&nbsp;найдёте всё необходимое для&nbsp;вашей кухни
        </Typography>
        <SwiperWithNavigation
          className={allPurchasesModalSwiper}
          onSlideNextTransitionEnd={handleNextSlideBtnClick}
          onSlidePrevTransitionEnd={handlePrevSlideBtnClick}
          slidesPerView="auto"
          watchOverflow>
          {additionalList.map(({ name, imgSrc, link }: KitchenAdditionalItemStructure, index: number) => (
            <SwiperSlide
              className={allPurchasesModalSlide}
              key={createElementKey('storage-add-item', index)}>
              <CategoryCardWithGAClickButton
                className={allPurchasesCategoryCard}
                elementBlock={KITCHEN_ELEMENT_BLOCK}
                elementName={name}
                elementText="Все покупки в Лемана ПРО / modal"
                {...link}>
                <CategoryCardHeader className={allPurchasesCategoryCardName} title={name} />
                <CategoryCardMedia
                  alt={name}
                  className={allPurchasesModalImage}
                  height={140}
                  src={imgSrc}
                  title={name}
                  width={156}
                />
              </CategoryCardWithGAClickButton>
            </SwiperSlide>
          ))}
        </SwiperWithNavigation>
      </ModalContent>
    </>
  );
};
